<ion-header no-border mode="md">
  <ion-toolbar mode="md" text-wrap>
    <div class="header-title-with-button">
      <div class="custom-title">
        {{ keyResult?.name }}
      </div>
      <!-- <ion-button mode="ios" fill="solid" color="secondary"
      (click)="goToGoals()" *ngIf="allowComments" >
      {{ 'goalProgressInfo.goalConfiguration' | translate }}
    </ion-button> -->
    </div>
    <ion-buttons slot="end">
      <ion-button mode="ios" size="small" color="secondary" (click)="dismiss()">
        <ion-icon class="bp-close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content id="modalContent" padding>
  <div id="canvasContainer" style="height: 320px;">
    <canvas
      id="myChart"
      width="555"
      style="margin-left: -5px;"
      [hidden]="!keyResult"
    ></canvas>
  </div>

  <ng-container>
    <ion-card mode="ios" class="goal-achivement-details">
      <ion-card-header *ngIf="isAdmin" color="primary">
        <div class="full-width">
          <ion-row lrm class="full-width">
            <ion-col class="achivement ion-align-self-center" size="4" size-md="4">
              {{ "okr.deadline" | translate }}
              <ion-datetime
                class="date-selection"
                lines="none"
                mode="ios"
                presentation="date"
                [locale]="'pt-BR'"
                [(ngModel)]="deadline"
                [value]="GetDateToString(deadline)"
              ></ion-datetime>
            </ion-col>
            <ion-col class="achivement" size="6" size-md="6" align-self-center>
              {{ "goalProgressInfo.goalAchievement" | translate }} (%)
              <ion-item
                class="currentProgress"
                lines="none"
                mode="ios"
                color="primary"
              >
                <ion-select [(ngModel)]="currentProgress">
                  <ion-select-option
                    *ngFor="let num of 100 | doLoop; let index = index"
                    [value]="index + 1"
                  >
                    {{ index + 1 }}%
                  </ion-select-option>
                </ion-select>
              </ion-item>
            </ion-col>
            <ion-col size="2" size-md="2" class="ion-align-self-center">
              <ion-button
                color="success"
                mode="ios"
                class="full-width"
                (click)="addNewProgress()"
              >
                Submit
              </ion-button>
            </ion-col>
          </ion-row>
        </div>
      </ion-card-header>
      <ion-card-content>
        <ion-item *ngIf="isAdmin; else elseBlock">
          <ion-textarea
            [placeholder]="'goalProgressInfo.newComment' | translate"
            [(ngModel)]="KeyResultComment"
          ></ion-textarea>
          <ion-button
            color="primary"
            mode="ios"
            (click)="saveKeyResultComment()"
          >
            {{ "OKR.saveComment" | translate }}
          </ion-button>
        </ion-item>

        <ng-template #elseBlock>
          <ion-item>
            <ion-textarea
              [placeholder]="'goalProgressInfo.newComment' | translate"
              [(ngModel)]="KeyResultComment"
              disabled
            ></ion-textarea>
          </ion-item>
        </ng-template>
      </ion-card-content>
    </ion-card>
  </ng-container>
</ion-content>
